var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgReplay = function SvgReplay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.374 3.959 7.291 5.834l2.083 1.875M10.625 16.041l2.083-1.875-2.083-1.875",
    stroke: "#6C6E76",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.125 5.834h2.917a5 5 0 0 1 5 5v.208M11.876 14.167H8.959a5 5 0 0 1-5-5V8.96",
    stroke: "#6C6E76",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgReplay;